import { styled } from "goober";
import { ConnectorLogoContainer } from "../ConnectorLogoContainer";
import { Icon } from "../Icon";
import { Text } from "../Text";
import { extensionFromMime } from "./download";
import { DownloadButton } from "./DownloadButton";
import type { FileRenderControl } from "./types";
import { useFileActions } from "./useFileActions";

const BinaryBodyRow = styled("div")`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  height: 48px;
  background: var(--surface-primary);
  border-radius: 12px;
  border: 0.5px solid var(--border-alpha);
`;

type Props = {
  url?: string;
  contentType: string;
  fileName?: string;
  note?: string;
  onControls?: (controls: FileRenderControl[]) => void;
  hideActions?: boolean;
};

export function Binary({
  url,
  contentType,
  fileName,
  note,
  onControls,
  hideActions,
}: Props) {
  const ext = extensionFromMime(contentType);
  const downloadName = fileName ?? `output.${ext}`;

  const { download, downloading } = useFileActions({
    url,
    fileName: downloadName,
    onControls,
  });

  return (
    <BinaryBodyRow style={{ paddingLeft: 8 }}>
      <ConnectorLogoContainer
        size={32}
        borderRadius={8}
        hoverBackground={false}
      >
        <Icon name="package-2" size={16} />
      </ConnectorLogoContainer>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          minWidth: 0,
          flex: 1,
        }}
      >
        <Text variant="text-regular" color="var(--text-primary)" ellipsis>
          {ext.toUpperCase()}
        </Text>
        {note != null && (
          <Text variant="text-small" color="var(--text-secondary)" ellipsis>
            {note}
          </Text>
        )}
      </div>
      {!onControls && !hideActions && (
        <div style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
          <DownloadButton onPress={download} disabled={!url || downloading}>
            <Icon name="arrow-down" size={12} />
            <Text variant="text-small-md">
              {downloading ? "Downloading…" : "Download"}
            </Text>
          </DownloadButton>
        </div>
      )}
    </BinaryBodyRow>
  );
}
